import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, ControlContainer } from '@angular/forms';

@Component({
  selector: 'app-expense-reimbursement-details',
  templateUrl: './expense-reimbursement-details.component.html',
  styleUrls: ['./expense-reimbursement-details.component.css']
})
export class ExpenseReimbursementDetailsComponent implements OnInit {
  @Input() expenseFormGroup: FormGroup;
  @Input() displayControl;
  reimbursementApplicable = ['Yes', 'No'];
  isTravelUser: any = false;
  loggedInUser: any;

  constructor(
    private controlContainer: ControlContainer
  ) {
    this.checkViewPermission()
    if (window.localStorage.getItem('currentUser')) {
      this.loggedInUser = JSON.parse(window.localStorage.getItem('currentUser'));
    }
  }

  checkViewPermission(){
    if(JSON.parse(localStorage.currentUser).roleValue == '5672') {
      this.isTravelUser = false
    }
    if(JSON.parse(localStorage.currentUser).roleValue == '3421') {
      this.isTravelUser = true
    }
    if(JSON.parse(localStorage.currentUser).roleValue == '9918' || '2898') {
      this.isTravelUser = true
    }
  }

  ngOnInit() {
    this.expenseFormGroup = <FormGroup>this.controlContainer.control;
  }

  onValueSelect($event) {
    console.log('value Selected:', $event)
  }

}
